import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataServiceConfig,
    HttpUrlGenerator,
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging/logging.service';
import moment from 'moment';
import { EfaactDataService } from '../efaact.data-service';
import { DeferBilling } from './defer-billing.model';

export const entityName = 'DeferBilling';

@Injectable()
export class DeferBillingDataService extends EfaactDataService<DeferBilling> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    mapItems(item: DeferBilling): DeferBilling {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.Txnid,
            Billdate: moment(item.Billdate).isValid() ? moment(item.Billdate).toDate() : null
        };
    }
}
